export enum EventBusEventsEnum {
    SNACKBAR_SHOW = 'SNACKBAR_SHOW',
    SHOW_CONFIRMATION_DIALOG = 'SHOW_CONFIRMATION_DIALOG',
    REFRESH_CHILD_USER_BUNDLE_MAPPING_TABS = 'REFRESH_CHILD_USER_BUNDLE_MAPPING_TABS',
    COMMUNICATION_MESSAGE_SENT = 'COMMUNICATION_MESSAGE_SENT',
}
